// extracted by mini-css-extract-plugin
export default {"languageList":"no-purify__languageSelector__languageList___hVJgm","languageItem":"no-purify__languageSelector__languageItem___CHK7A"};